module.exports = __webpack_public_path__ + "static/media/card-blog9.fa476a38.jpg";